// extracted by mini-css-extract-plugin
export default {"main_wrap":"SignSelf_main_wrap__eIvP3","custom_dot":"SignSelf_custom_dot__Yq38V"};